module.exports = __webpack_public_path__ + "img/our-mission-shape2.2882f6f9.png";